import TradingViewWidget from "react-tradingview-widget";

function TradingViewChart({ symbol }) {
  return (
    <div className="charts" style={{
      height: "100%",
      border: "1px solid #E1BA7840",
      borderRadius: "12px",
      overflow: "hidden", 
      boxShadow: "0px 4px 4px 0px #E1BA7840",
    }}>
      <TradingViewWidget
        symbol={symbol}
        locale="fr"
        height="100%"
        autosize={true}
        theme="light"
        interval="30"
        timezone="Etc/UTC"
        style="1"
        enable_publishing={false}
        hide_top_toolbar={true}
        hide_legend={true}
        save_image={false}
        hide_volume={true}
        
      />
    </div>
  );
}
export default TradingViewChart;
